import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "right-wrap" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "tab-nav" }
const _hoisted_5 = { class: "leftitem" }
const _hoisted_6 = { class: "card-box" }
const _hoisted_7 = { class: "card-tab" }
const _hoisted_8 = { class: "datafix" }
const _hoisted_9 = { class: "button-box" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "text-num" }

import { ref, onMounted } from "vue";

import CreatorSidebar from "@/components/CreatorSidebar.vue";
import CreatorHeader from "@/components/CreatorHeader.vue";
import { useHead } from "@vueuse/head";
import { WebSite_Name } from "@/interface/globalindex";
import axiosInstance from "@/utils/axiosInstance";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreatorHome',
  setup(__props) {

const activeTab = ref<string>("all");

const SSRData = ref({
  title: "创作者中心 - " + WebSite_Name,
  description:
    "默认代码,defaultcode.com 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。",
  keywords:
    "默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区",
});

// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: "description", content: SSRData.value.description },
    { name: "keywords", content: SSRData.value.keywords },
  ],
});

const articleinfo = ref({
  articleCount: 0,
  articleLastCount: 0
});

onMounted(() => {
  activeTab.value = "all";
  fetchArticleStatistics();
});


// 文章统计
const fetchArticleStatistics = async () => {
  try {
    const response = await axiosInstance.get(
      "/api/ArticleInfo/GetArticleStatistics",
      {
        params: {
        },
      }
    );
    var result = response.data;
    if (result.success) {
      articleinfo.value.articleCount = result.data.TotalCount;
      articleinfo.value.articleLastCount = result.data.Last30DaysCount;
    }
  } catch (error) {
    console.error("fail:", error);
  }
};


return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "creator-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "header" }, {
        default: _withCtx(() => [
          _createVNode(CreatorHeader)
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(CreatorSidebar),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_tabs, {
                      modelValue: activeTab.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "数据概览",
                          name: "all",
                          style: {"font-size":"18px"}
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "label" }, [
                      _createElementVNode("span", { class: "label-text" }, "最近30天新增文章 ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(articleinfo.value.articleLastCount), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, [
                        _cache[1] || (_cache[1] = _createTextVNode("总计")),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(articleinfo.value.articleCount), 1),
                        _cache[2] || (_cache[2] = _createTextVNode("篇文章"))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})